import React, { useState } from 'react';

import {
  Grid,
  makeStyles,
  useTheme, useMediaQuery,
} from '@material-ui/core';
import CssBaseline from "@material-ui/core/CssBaseline";

import MainToolbar from "../MainToolbar";
import SettingsDrawer from "../shared/SettingsDrawer";
import {cyberStyles} from "../cssShared/cyberTheme";

const useStyles = makeStyles(theme => ({
  ...cyberStyles(theme),
}));

const ReportLayoutPage = ({ children, filter }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [hideDrawer, setHideDrawer] = useState(() => localStorage.getItem('hideDrawer') === 'true');

  return (
      <div className={classes.settingRoot}>
        <CssBaseline />

        {!isMobile && <div className={classes.appBarWrapper}>
          <MainToolbar/>
        </div>}

        <SettingsDrawer
            hideDrawer={hideDrawer}
            setHideDrawer={setHideDrawer}
            page={'repport'}
        />

        <main className={classes.content}>
          <div className={classes.toolbarSpacer} />
          <Grid container direction="column">
            {filter && (
                <Grid item className={classes.filterWrapper}>
                  {filter}
                </Grid>
            )}
            <Grid item style={{ flexGrow: 1 }}>
              {children}
            </Grid>
          </Grid>
        </main>
      </div>
  );
}

export default React.memo(ReportLayoutPage);